var modules_74c5b1b9 = {"container":"_1ye1b56","fullscreen":"_1bmij00","overlay":"_1kjfisc","backdrop":"_4h2jo0","header":"_szyf05","content":"_rg89ov","title":"_healus","title-wrapper":"_1po9cei","subtitle":"_4wgkac","close":"_8s5uhj","icon":"_nzp8gt","footer":"_lp7tts","default-direction":"_k16h6g","default-justify":"_gou0tb"};
import "../../../assets/D3Iq-i0a.css";

export { modules_74c5b1b9 as default };
//# sourceMappingURL=Dialog.module.less.js.map
